export const versionInfo = (() => {
  try {
    return require("./build-version.json");
  } catch {
    return console.log("Erro ao carregar arquivo de versão");
  }
})();
